import { ApiError } from '@clouway/api'

/**
 * A request that never produced an HTTP response (DNS failure, timeout,
 * connection refused). Extends ApiError so the lib's toApiError funnel returns
 * it untouched instead of re-wrapping it.
 */
export class NetworkError extends ApiError {
  constructor(message = 'Network error', options?: { cause?: unknown }) {
    super(message, options)
    this.name = 'NetworkError'
  }
}
